// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.
import metadata from '../../metadata.min.json.js'

export default function withMetadataArgument(func, _arguments) {
	var args = Array.prototype.slice.call(_arguments)
	args.push(metadata)
	return func.apply(this, args)
}


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/min/exports/withMetadataArgument.js
// module id = 661
// module chunks = 0